/** Await all in-flight parts before advancing the four-part signing window. */
export async function runUploadBatches(count: number, parallel: number,
  upload: (partNumber: number) => Promise<void>): Promise<void> {
  if (!Number.isInteger(count) || count < 1 || !Number.isInteger(parallel) || parallel < 1 || parallel > 4) {
    throw new RangeError('Invalid upload concurrency');
  }
  for (let first = 1; first <= count; first += parallel) {
    const results = await Promise.allSettled(Array.from(
      { length: Math.min(parallel, count - first + 1) }, (_, index) => upload(first + index)));
    const failure = results.find((result): result is PromiseRejectedResult => result.status === 'rejected');
    if (failure) throw failure.reason;
  }
}
